

      <!-- PTZ Controller -->
      <div class="col-lg-12">
        <div class="">
          <div class="row" *ngIf="app.customer">
            <div class="col-xs-12 ptz-home" *ngIf="!app.customer.enableControl" >
              <span class="badge bg-danger" title="Your customer tenancy does not have permission to control cameras.">Control Disabled</span>
            </div>
            <div class="col-xs-12 ptz-home">
              <table class="ptz" *ngIf="!simple">
                <tr>
                  <td></td>
                  <td><button [disabled]="!app.customer.enableControl" (click)="compass('nw')" type="button" class="btn btn-sm btn-outline-default compass">NW</button></td>
                  <td><button [disabled]="!app.customer.enableControl" (click)="compass('n')" type="button" class="btn btn-sm btn-outline-default">N</button></td>
                  <td><button [disabled]="!app.customer.enableControl" (click)="compass('ne')" type="button" class="btn btn-sm btn-outline-default compass">NE</button></td>
                  <td></td>
                </tr>
                <tr>
                  <td></td>
                  <td><button [disabled]="!app.customer.enableControl" (click)="compass('w')" type="button" class="btn btn-sm btn-outline-default">W</button></td>
                  <td>+</td>
                  <td><button [disabled]="!app.customer.enableControl" (click)="compass('e')" type="button" class="btn btn-sm btn-outline-default">E</button></td>
                </tr>
                <tr>
                  <td></td>
                  <td><button [disabled]="!app.customer.enableControl" (click)="compass('sw')" type="button" class="btn btn-sm btn-outline-default compass">SW</button></td>
                  <td><button [disabled]="!app.customer.enableControl" (click)="compass('s')" type="button" class="btn btn-sm btn-outline-default">S</button></td>
                  <td><button [disabled]="!app.customer.enableControl" (click)="compass('se')" type="button" class="btn btn-sm btn-outline-default compass">SE</button></td>
                </tr>
              </table> 
            </div>
            <div class="col-xs-12 ptz-home">
              <table class="ptz">
                <tr *ngIf="!simple">
                  <td></td>
                  <td></td>
                  <td><button [disabled]="!app.customer.enableControl" (click)="control('up',5)" type="button" class="btn btn-sm btn-outline-primary"><i class="fa fa-angle-double-up"></i></button></td>
                </tr>
                <tr>
                  <td *ngIf="!simple"></td>
                  <td></td>
                  <td><button [disabled]="!app.customer.enableControl" (click)="control('up',1)" type="button" class="btn btn-sm btn-outline-primary"><i class="fa fa-angle-up"></i></button></td>
                </tr>

                <tr>
                  <td *ngIf="!simple"><button [disabled]="!app.customer.enableControl" (click)="control('left',5)" type="button" class="btn btn-sm btn-outline-primary"><i class="fa fa-angle-double-left"></i></button></td>
                  <td><button [disabled]="!app.customer.enableControl" (click)="control('left',1)" type="button" class="btn btn-sm btn-outline-primary"><i class="fa fa-angle-left"></i></button></td>
                  <td><button  *ngIf="!simple" [disabled]="!app.customer.enableControl" (click)="photo()" type="button" class="btn btn-sm btn-outline-default"><i class="fa fa-camera"></i></button></td>
                  <td><button [disabled]="!app.customer.enableControl" (click)="control('right',1)" type="button" class="btn btn-sm btn-outline-primary"><i class="fa fa-angle-right"></i></button></td>
                  <td *ngIf="!simple"><button [disabled]="!app.customer.enableControl" (click)="control('right',5)" type="button" class="btn btn-sm btn-outline-primary"><i class="fa fa-angle-double-right"></i></button></td>
                  <!--<td><button [disabled]="!app.customer.enableControl" (click)="control(ts, 'right',10)" type="button" class="btn btn-sm btn-outline-primary"><i class="fa fa-arrow-right"></i></button></td>-->
                </tr>
                <tr>
                  <td *ngIf="!simple"></td>
                  <td></td>
                  <td><button [disabled]="!app.customer.enableControl" (click)="control('down',1)" type="button" class="btn btn-sm btn-outline-primary"><i class="fa fa-angle-down"></i></button></td>
                  <td></td>
                  <td *ngIf="!simple"></td>
                </tr>
                <tr *ngIf="!simple">
                  <td></td>
                  <td></td>
                  <td><button [disabled]="!app.customer.enableControl" (click)="control('down',5)" type="button" class="btn btn-sm btn-outline-primary"><i class="fa fa-angle-double-down"></i></button></td>
                  <td></td>
                  <td *ngIf="!simple"></td>
                </tr>
              </table>
            </div>
            <div class="col-12 ptz-home">
              <table class="ptz">
                <tr>
                  <td><button [disabled]="!app.customer.enableControl" (click)="zoom('in')" type="button" class="btn btn-sm btn-outline-primary"><i class="fa fa-plus"></i></button></td>
                  <td><button [disabled]="!app.customer.enableControl" (click)="zoom('out')" type="button" class="btn btn-sm btn-outline-primary"><i class="fa fa-minus"></i></button></td>
                  
                  <td><!--<button [disabled]="!app.customer.enableControl" (click)="control(ts, 'down',10)" type="button" class="btn btn-sm btn-outline-primary"><i class="fa fa-arrow-down"></i></button>--></td>
                  <!--<td></td>-->
                  <td *ngIf="!simple"><button [disabled]="!app.customer.enableControl" (click)="savePtz()" title="Save Current Location" type="button" class="btn btn-sm btn-outline-default"><i class="fa fa-save"></i></button></td>
                  <td *ngIf="!simple"><button [disabled]="!app.customer.enableControl" (click)="loadPtz()" title="Open Saved Location" type="button" class="btn btn-sm btn-outline-default"><i class="fa fa-binoculars"></i></button></td>
                </tr>
                <tr *ngIf="!simple">
                  <td colspan="3">Direction:</td>
                  <td colspan="3"><input type="number" [disabled]="!app.customer.enableControl" class="form-control from-control-sm" [(ngModel)]="ptzDirection" title="Direction" min="0" max="359"></td>
                </tr>
                <tr *ngIf="!simple">
                  <td colspan="3">Elevation:</td>
                  <td colspan="3"><input type="number" [disabled]="!app.customer.enableControl" class="form-control from-control-sm" [(ngModel)]="ptzElevation" title="Elevation" min="-20" max="20"></td>
                </tr>
                <tr *ngIf="!simple">
                  <td colspan="3">Zoom:</td>
                  <td colspan="3"><input type="number" [disabled]="!app.customer.enableControl" class="form-control from-control-sm" [(ngModel)]="ptzZoom" title="Zoom" min="0" max="47"></td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
   